import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { colors, gridSize } from '@atlaskit/theme';

const FormInfo = styled.div`
  color: ${colors.N700};
  font-size: 13px;
  line-height: 17px;
  margin-bottom: 24px;
  margin-top: -4px;
  transform: rotateX(0deg);
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-bottom, opacity, transform, padding;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;
  text-align: center;

  &.hidden {
    height: 0;
    margin-bottom: 0;
    opacity: 0;
    padding: 0 ${gridSize() * 2}px;
    pointer-events: none;
    transform: rotateX(-90deg);
    visibility: hidden;
  }
`;

type Props = {
  id: string;
  isHidden?: boolean;
  children: ReactNode;
};

const FormInfoComponent = ({ children, ...props }: Props) => {
  return (
    <FormInfo role="alert" {...props} className={props.isHidden ? 'hidden' : ''}>
      {children}
    </FormInfo>
  );
};

export default FormInfoComponent;
